var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _g2, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _g3, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g4, _path56, _g5, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBussinessStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 270,
    height: 270,
    viewBox: "0 0 270 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M198.578 194.258C194.746 198.293 191.119 200.895 188.254 202.951C154.574 227.116 114.722 220.072 106.253 218.352C93.7456 215.812 69.5697 210.901 52.0909 190.347C25.6469 159.249 29.7647 110.256 50.2763 77.9149C54.0282 71.9991 73.8469 39.1655 114.128 33.9C138.506 30.7134 166.923 37.1404 187.501 54.3812C230.698 90.5711 227.623 163.681 198.578 194.258Z",
    fill: "url(#paint0_linear_171_1178)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6578 130.123C77.6578 130.123 78.1422 109.758 68.762 104.307C59.3817 98.8561 41.5467 95.4483 40.8782 66.2052C40.4868 49.0849 40.0631 41.5997 39.7792 38.3358C39.6685 37.0626 40.7999 36.0349 42.0558 36.2715C50.9396 37.9451 79.7993 44.8336 85.85 64.5316C93.0231 87.8839 77.6578 130.123 77.6578 130.123Z",
    fill: "url(#paint1_linear_171_1178)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9263 44.4078C58.6781 53.105 69.9542 68.4972 75.9645 83.8897C76.736 86.4264 78.9927 91.821 79.9727 101.406C80.8479 109.4 80.4128 117.847 79.3515 123.439C79.2844 123.792 78.9435 124.024 78.5899 123.957C77.9821 123.842 78.0629 123.188 78.0684 123.209C79.2805 113.655 78.7774 101.765 76 91.0355C72.4516 77.8616 64.5373 65.089 56.3514 54.2559L55.509 53.1892C49.1668 45.0444 47.8317 44.9844 48.4246 44.4166C48.5646 44.2825 48.7838 44.2813 48.9263 44.4078Z",
    fill: "#1F5AA9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1875 176.511C77.3186 177.358 67.3745 158.474 68.167 131.923C68.5404 119.411 71.397 104.187 65.5881 97.0117C60.7535 91.0401 40.5734 90.4111 33.9397 90.3682C33.1107 90.3628 32.6493 91.3238 33.1738 91.9658C35.7598 95.1304 41.1842 102.467 41.7358 108.931C42.4626 117.45 49.1809 124.053 55.8041 126.75C62.4273 129.447 66.0023 131.524 67.272 143.173C68.5416 154.822 72.9733 174.102 76.1875 176.511Z",
    fill: "url(#paint2_linear_171_1178)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3103 95.4946C50.4261 97.3863 58.5009 102.781 61.6316 110.625L61.9258 111.372C62.6006 113.122 65.998 125.299 67.3081 135.108C67.3244 135.23 67.2385 135.342 67.1163 135.359C66.9086 135.386 66.8514 135.153 66.8665 135.175C65.7234 129.558 63.9153 122.368 62.4143 116.963C60.8224 111.074 59.6852 107.074 54.3867 102.446C48.4654 97.4215 42.2003 95.8333 42.2186 95.8408C42.1237 95.8126 42.0696 95.7128 42.0978 95.6179C42.125 95.5268 42.2188 95.4735 42.3103 95.4946Z",
    fill: "#222669"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.419 72.8245L116.89 66.6556L57.3618 73.6315V222.026L116.89 218.353L176.419 222.425L235.873 216.209V69.3751L176.419 72.8245Z",
    fill: "url(#paint3_linear_171_1178)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.168 214.969L61.6082 218.454V77.6813L118.168 71.0637V214.969Z",
    fill: "url(#paint4_linear_171_1178)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.728 218.833L118.168 214.97V71.0637L174.728 76.9158V218.833Z",
    fill: "url(#paint5_linear_171_1178)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M231.218 212.936L174.728 218.833V76.9159L231.218 73.6437V212.936Z",
    fill: "url(#paint6_linear_171_1178)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M118.168 71.0637H116.888V215.009H118.168V71.0637Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_171_1178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 70,
    width: 171,
    height: 149
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M174.638 76.7266L118.078 70.8745L61.5181 77.4921V218.265L118.078 214.78L174.638 218.643L231.128 212.747V73.4544L174.638 76.7266Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_171_1178)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M191.103 78.337L205.767 89.5567L195.772 98.9277L183.993 87.9688L191.103 78.337Z",
    fill: "url(#paint7_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9575 100.361L96.1807 87.9689L117.528 94.1649V109.887L94.9575 100.361Z",
    fill: "url(#paint8_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.19 177.459L229.029 171.547L230.631 183.539L220.283 186.863L217.19 177.459Z",
    fill: "url(#paint9_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.641 187.002L117.528 193.116L129.378 191.157L128.307 183.054L117.528 180.561L105.641 187.002Z",
    fill: "url(#paint10_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5194 100.717L61.2637 112.074L61.9526 114.726L66.6111 113.085L96.4588 122.524L96.9579 120.385L70.0477 111.875L93.1403 103.745L114.684 120.287L111.719 144.159L88.1589 146.106L67.4399 178.635L69.3516 180.285L89.4189 148.779L113.8 146.764L117.255 118.942L93.5194 100.717Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4522 196.573L58.8232 172.268L60.3621 170.155L84.991 194.46L83.4522 196.573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.956 172.352L163.259 130.22L161.054 131.263L168.786 153.429L131.233 166.871L131.933 169.519L169.685 156.006L175.751 173.395L177.956 172.352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.354 164.155L202.198 173.216L188.064 140.925L186.368 141.932L200.814 174.938L200.859 174.912L195.347 181.89L197.099 183.765L211.105 166.03L209.354 164.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.747 108.166L199.366 105.91C199.305 105.96 199.268 106.002 199.266 106.005C200.022 105.144 210.276 90.6976 216.985 81.1971L217.822 80.0116L233.081 97.953L231.39 99.9023L217.986 84.1417C216.512 86.2264 213.308 90.7569 210.098 95.2739C201.208 107.783 200.963 107.987 200.747 108.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 122.851L165.219 103.797L159.375 86.4282L133.217 88.2385L133.076 85.4729L160.96 83.5431L167.488 102.961L172.285 122.074L170 122.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.8094 100.948L92.9111 100.779L93.9019 85.6929L117.72 91.4238L117.335 93.5941L95.6354 88.3732L94.8094 100.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.474 100.545L194.286 98.8134L204.193 89.6026L190.466 78.1007L191.579 76.3018L207.342 89.5109L195.474 100.545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.888 186.243L218.098 121.078L215.808 121.83L227.725 171.012L216.578 176.579L217.328 178.615L228.039 173.266L229.323 182.872L220.983 185.551L221.489 187.688L231.023 184.625L231.598 186.995L233.888 186.243Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.935 212.168L82.9165 195.95L83.7963 193.375L117.084 208.792L126.559 193.365L118.042 195.733L103.534 187.875L104.538 185.364L118.295 192.815L132.197 188.949L117.935 212.168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.006 182.424L170.176 212.45L145.964 186.248L132.329 166.213L130.837 167.589L144.517 187.69L144.562 187.756L168.884 214.078L165.105 218.839L166.853 220.719L195.754 184.304L194.006 182.424Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_171_1178",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 70,
    width: 171,
    height: 149
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.638 76.7266L118.078 70.8745L61.5181 77.4921V218.265L118.078 214.78L174.638 218.643L231.128 212.747V73.4544L174.638 76.7266Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_171_1178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.232 121.665L116.916 110.957C98.2776 103.309 77.0495 95.4013 60.5825 94.4928L60.684 92.0021C77.5037 92.9302 99.0378 100.969 117.884 108.711L118.14 108.816L126.821 119.993L125.232 121.665Z",
    fill: "url(#paint11_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.833 206.973C211.678 193.998 191.142 179.716 176.874 174.194L130.495 194.122L129.753 191.783L176.832 171.554L177.186 171.688C191.689 177.194 212.544 191.692 230.954 204.848L229.833 206.973Z",
    fill: "url(#paint12_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.272 112.724L125.034 71.6903L127.02 70.7563L141.258 111.79L139.272 112.724Z",
    fill: "url(#paint13_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.797 124.083C200.114 107.45 193.018 95.995 182.104 89.0631L183.13 86.8744C189.152 90.699 194.145 95.9157 197.971 102.38C201.446 108.251 204.03 115.146 205.871 123.46L203.797 124.083Z",
    fill: "url(#paint14_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6129 192.451L90.8252 191.056L111.866 153.348L113.654 154.743L92.6129 192.451Z",
    fill: "url(#paint15_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.706 125.499L147.892 122.631L147.977 120.139L209.325 122.986L231.829 112.246L232.642 114.553L209.706 125.499Z",
    fill: "url(#paint16_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9934 206.834L61.2227 204.508L117.38 179.291L128.413 180.567L128.201 183.048L117.675 181.831L61.9934 206.834Z",
    fill: "url(#paint17_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.364 156.215C110.253 155.918 87.6567 154.492 76.1318 140.492L77.6783 138.767C88.6275 152.067 110.75 153.43 134.387 153.722L134.364 156.215Z",
    fill: "url(#paint18_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.248 215.215L127.208 180.265L127.285 179.98L141.802 126.103L148.309 113.28L174.058 97.0796L191.235 75.0752L192.82 76.752L175.398 99.0711L149.851 115.144L143.772 127.124L129.406 180.441L134.361 214.802L132.248 215.215Z",
    fill: "url(#paint19_linear_171_1178)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.316 212.538L202.229 149.159L146.608 125.439L136.709 122.69L100.778 119.528L61.1042 153.372L59.8381 151.361L100.151 116.972L100.545 117.007L137.04 120.218L147.227 123.047L147.286 123.072L203.717 147.138L203.91 147.545L234.19 211.331L232.316 212.538Z",
    fill: "url(#paint20_linear_171_1178)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.69,
    d: "M142.787 126.614C146.755 126.614 149.971 123.4 149.971 119.435C149.971 115.471 146.755 112.257 142.787 112.257C138.819 112.257 135.603 115.471 135.603 119.435C135.603 123.4 138.819 126.614 142.787 126.614Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.787 124.579C145.63 124.579 147.935 122.276 147.935 119.436C147.935 116.595 145.63 114.292 142.787 114.292C139.944 114.292 137.639 116.595 137.639 119.436C137.639 122.276 139.944 124.579 142.787 124.579Z",
    fill: "url(#paint21_linear_171_1178)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M185.22 223.205C191.021 223.205 195.723 218.503 195.723 212.702C195.723 206.901 191.021 202.198 185.22 202.198C179.419 202.198 174.716 206.901 174.716 212.702C174.716 218.503 179.419 223.205 185.22 223.205Z",
    fill: "url(#paint22_linear_171_1178)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M238.149 96.7321C238.149 116.709 208.061 167.674 192.388 192.813C191.171 194.764 188.551 195.948 183.7 195.948C181.401 195.948 182.305 194.759 181.089 192.808C165.415 167.666 135.331 116.706 135.331 96.7321C135.331 70.6838 158.347 49.5675 186.74 49.5675C215.133 49.5674 238.149 70.6838 238.149 96.7321Z",
    fill: "url(#paint23_linear_171_1178)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M235.109 96.7321C235.109 116.709 205.021 167.674 189.348 192.813C188.131 194.764 185.995 195.949 183.696 195.948C181.397 195.947 179.265 194.759 178.049 192.808C162.374 167.666 132.291 116.706 132.291 96.7321C132.291 70.6838 155.307 49.5675 183.7 49.5675C212.093 49.5674 235.109 70.6838 235.109 96.7321Z",
    fill: "url(#paint24_linear_171_1178)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 137.117C204.327 137.117 221.048 120.396 221.048 99.7696C221.048 79.1431 204.327 62.422 183.7 62.422C163.074 62.422 146.353 79.1431 146.353 99.7696C146.353 120.396 163.074 137.117 183.7 137.117Z",
    fill: "url(#paint25_linear_171_1178)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M208.814 120.956H159C158.796 120.956 158.63 120.79 158.63 120.586V89.8169C158.63 89.6128 158.796 89.4471 159 89.4471H208.814V90.1867H159.37V120.217H208.445V92.2474H209.184V120.586C209.184 120.79 209.019 120.956 208.814 120.956Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M202.102 114.062H182.271C180.76 114.062 179.531 112.832 179.531 111.321V99.9787C179.531 98.5289 180.71 97.3496 182.16 97.3496H202.102C203.613 97.3496 204.842 98.5788 204.842 100.09V111.321C204.842 112.832 203.613 114.062 202.102 114.062ZM182.16 97.8426C180.982 97.8426 180.024 98.8007 180.024 99.9787V111.321C180.024 112.56 181.032 113.569 182.271 113.569H202.102C203.341 113.569 204.349 112.56 204.349 111.321V100.09C204.349 98.8508 203.341 97.8427 202.102 97.8427H182.16V97.8426Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M176.097 119.736H163.348V103.238C163.348 102.212 164.183 101.377 165.209 101.377H174.534C175.396 101.377 176.097 102.078 176.097 102.94L176.097 119.736ZM163.841 119.243H175.604V102.94C175.604 102.35 175.124 101.87 174.534 101.87H165.209C164.455 101.87 163.841 102.484 163.841 103.238V119.243Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M175.593 121.525H163.397C163.254 121.525 163.139 121.41 163.139 121.268V119.701C163.139 119.517 163.288 119.369 163.471 119.369H175.518C175.702 119.369 175.851 119.517 175.851 119.701V121.268C175.851 121.41 175.735 121.525 175.593 121.525Z",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.76
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.86 113.815H180.513C180.107 113.815 179.777 113.485 179.777 113.079V98.2995C179.777 97.911 180.092 97.5961 180.481 97.5961H203.86C204.266 97.5961 204.596 97.9257 204.596 98.3323V113.079C204.596 113.485 204.266 113.815 203.86 113.815Z",
    fill: "white"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M175.851 119.49H163.594V102.1C163.594 101.837 163.808 101.623 164.071 101.623H175.462C175.677 101.623 175.851 101.797 175.851 102.012L175.851 119.49Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M175.593 121.525H163.397C163.254 121.525 163.139 121.41 163.139 121.268V119.701C163.139 119.517 163.288 119.369 163.471 119.369H175.518C175.702 119.369 175.851 119.517 175.851 119.701V121.268C175.851 121.41 175.735 121.525 175.593 121.525Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M174.886 90.4768L166.249 90.4501L166.281 90.1757C166.583 87.6041 167.49 82.7911 170.166 79.4485L170.24 79.3561H177.48L177.264 79.7268C175.582 82.6122 175.048 87.0372 174.897 90.2412L174.886 90.4768ZM166.805 89.9589L174.416 89.9823C174.578 86.8795 175.101 82.7417 176.632 79.849H170.477C168.025 82.9766 167.128 87.4091 166.805 89.9589Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M166.745 90.4518L158.935 90.4277L158.988 90.1382C159.559 86.9809 160.874 82.5606 163.888 79.4317L163.96 79.3561H170.871L170.551 79.7566C167.952 83.0032 167.067 87.7141 166.771 90.2334L166.745 90.4518ZM159.527 89.9367L166.308 89.9574C166.622 87.4451 167.49 83.0704 169.859 79.8491H164.171C161.383 82.7904 160.108 86.8964 159.527 89.9367Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M182.568 90.5004L174.392 90.4753L174.404 90.218C174.558 86.9589 175.106 82.4502 176.838 79.4783L176.909 79.3561H182.568L182.568 90.5004ZM174.91 89.9837L182.075 90.0059V79.849H177.194C175.611 82.6587 175.075 86.8493 174.91 89.9837Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M159.436 90.4294L154.167 90.4132L154.143 90.1939C154.135 90.126 153.489 83.363 160.353 79.3892L160.41 79.356H164.645L164.242 79.7734C161.314 82.8136 160.032 87.1356 159.472 90.2262L159.436 90.4294ZM154.619 89.9216L159.025 89.9349C159.59 86.9336 160.821 82.8756 163.502 79.849H160.543C157.147 81.8356 155.721 84.5132 155.122 86.4146C154.608 88.0502 154.599 89.4086 154.619 89.9216Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M206.629 90.5743L198.804 90.55L198.779 90.3321C198.489 87.7882 197.61 83.0315 194.988 79.7565L194.667 79.356H201.579L201.651 79.4316C204.702 82.5982 206.014 87.0812 206.578 90.2842L206.629 90.5743ZM199.243 90.0584L206.04 90.0793C205.466 86.9943 204.191 82.8279 201.368 79.849H195.68C198.071 83.0999 198.935 87.5208 199.243 90.0584Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M213.009 90.5936L206.128 90.5726L206.092 90.3694C205.54 87.2341 204.26 82.8507 201.296 79.7734L200.894 79.356H205.292L205.339 79.376C205.415 79.4087 213.009 82.7511 213.009 90.3463V90.5936ZM206.541 90.081L212.513 90.099C212.357 83.3009 205.796 80.1277 205.189 79.849H202.037C204.753 82.9143 205.984 87.0345 206.541 90.081Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M191.149 90.5267L182.075 90.499V79.3561H188.63L188.701 79.4783C190.44 82.462 190.985 86.9926 191.137 90.2682L191.149 90.5267ZM182.568 90.0074L190.632 90.0322C190.469 86.8817 189.934 82.67 188.345 79.8491H182.568V90.0074Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M199.301 90.5516L190.655 90.5251L190.644 90.2907C190.496 87.0706 189.964 82.6237 188.275 79.7267L188.059 79.356H195.299L195.373 79.4484C198.072 82.8199 198.973 87.6794 199.269 90.2762L199.301 90.5516ZM191.126 90.0336L198.747 90.0568C198.428 87.4821 197.535 83.0049 195.062 79.8491H188.907C190.445 82.7542 190.966 86.9144 191.126 90.0336Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M154.388 90.1674C154.388 90.1674 153.672 83.542 160.476 79.6027H164.065C161.039 82.744 159.761 87.2503 159.23 90.1822L154.388 90.1674Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M166.526 90.2045C166.889 87.1129 167.881 82.6966 170.358 79.6025H177.051C175.33 82.5537 174.799 87.0761 174.65 90.2294L166.526 90.2045Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M182.322 90.253V79.6025H188.488C190.217 82.5691 190.745 87.1239 190.89 90.2793L182.322 90.253Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M199.024 90.3043C198.671 87.2086 197.684 82.7301 195.181 79.6027H201.474C204.55 82.7959 205.82 87.4001 206.335 90.3268L199.024 90.3043Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M156.337 92.6502C155.479 92.6502 154.834 92.4032 154.419 91.9164C153.793 91.1817 153.945 90.1829 153.952 90.1408L153.984 89.9407L159.681 89.7366L159.611 90.0478C159.606 90.0738 159.002 92.6502 156.337 92.6502ZM154.425 90.4181C154.42 90.6963 154.463 91.2099 154.797 91.5994C155.114 91.9696 155.632 92.1571 156.337 92.1571C158.102 92.1571 158.8 90.8661 159.032 90.2531L154.425 90.4181Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M163.297 92.6502C159.934 92.6502 159.142 90.09 159.134 90.064L159.042 89.7479H166.963L166.934 90.0207C166.742 91.8145 165.586 92.6502 163.297 92.6502ZM159.739 90.2409C160.048 90.8584 160.974 92.1572 163.297 92.1572C165.213 92.1572 166.16 91.5804 166.404 90.2409H159.739Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M170.972 93.0206C169.036 93.0206 167.911 92.2204 167.308 91.549C166.65 90.8174 166.457 90.0863 166.449 90.0555L166.371 89.7478H175.086L175.054 90.0235C174.827 91.9282 173.34 93.0206 170.972 93.0206ZM167.038 90.2409C167.334 90.9306 168.307 92.5276 170.972 92.5276C172.971 92.5276 174.219 91.7185 174.52 90.2409H167.038Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M178.815 93.0207C176.958 93.0207 175.878 92.2181 175.3 91.545C174.672 90.8137 174.488 90.0837 174.48 90.0531L174.405 89.7479H182.759L182.728 90.0224C182.512 91.9277 181.085 93.0207 178.815 93.0207ZM175.064 90.2409C175.345 90.9287 176.273 92.5277 178.815 92.5277C180.72 92.5277 181.91 91.7186 182.196 90.2409H175.064Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M210.087 92.6502C206.845 92.6502 206.102 90.0856 206.095 90.0597L206.007 89.7383L212.94 89.9391L212.978 90.1319C212.985 90.1685 213.15 91.0407 212.56 91.76C212.075 92.3507 211.243 92.6502 210.087 92.6502ZM206.698 90.2515C206.992 90.8707 207.871 92.1572 210.087 92.1572C211.088 92.1572 211.792 91.9184 212.178 91.4472C212.477 91.083 212.518 90.6598 212.512 90.4198L206.698 90.2515Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M202.455 92.6501C200.166 92.6501 199.011 91.8145 198.819 90.0206L198.79 89.7478H206.711L206.618 90.0639C206.61 90.0896 205.818 92.6501 202.455 92.6501ZM199.348 90.2409C199.593 91.5803 200.539 92.1571 202.455 92.1571C204.755 92.1571 205.694 90.8567 206.009 90.2409H199.348Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M194.751 93.0206C192.359 93.0206 190.856 91.9284 190.627 90.0237L190.594 89.7478H199.4L199.32 90.0562C199.312 90.0869 199.117 90.8183 198.453 91.55C197.843 92.2209 196.706 93.0206 194.751 93.0206ZM191.161 90.2409C191.465 91.7185 192.728 92.5276 194.751 92.5276C197.418 92.5276 198.419 90.9287 198.727 90.2409H191.161Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M186.608 93.0207C184.074 93.0207 182.482 91.929 182.239 90.0257L182.204 89.7479H191.535L191.449 90.0599C191.44 90.0908 191.233 90.8238 190.526 91.5556C189.88 92.2238 188.676 93.0207 186.608 93.0207ZM182.776 90.2409C183.101 91.7186 184.449 92.5277 186.608 92.5277C189.449 92.5277 190.519 90.9316 190.848 90.2409H182.776Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M154.195 90.1796C154.195 90.1796 153.838 92.4035 156.337 92.4035C158.835 92.4035 159.371 89.9943 159.371 89.9943L154.195 90.1796Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M174.809 89.9944H166.688C166.688 89.9944 167.401 92.7743 170.972 92.7743C173.349 92.7743 174.611 91.6623 174.809 89.9944Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M182.483 89.9944H191.211C191.211 89.9944 190.445 92.7743 186.607 92.7743C184.053 92.7743 182.696 91.6623 182.483 89.9944Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M199.064 89.9944H206.381C206.381 89.9944 205.673 92.4036 202.455 92.4036C200.313 92.4036 199.242 91.6623 199.064 89.9944Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M212.215 89.9549H154.215L154.113 89.6718C154.073 89.6121 154.322 89.5594 154.643 89.5594L212.095 89.559C212.322 89.5593 212.524 89.5856 212.604 89.6253L212.727 89.6868C212.861 89.7537 212.597 89.8251 212.215 89.9549Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 138.696C162.671 138.696 145.563 121.588 145.563 100.559C145.563 100.182 145.869 99.8758 146.246 99.8758C146.624 99.8758 146.93 100.182 146.93 100.559C146.93 120.834 163.425 137.33 183.7 137.33C203.975 137.33 220.47 120.834 220.47 100.559C220.47 80.2837 203.975 63.7886 183.7 63.7886C171.976 63.7886 161.226 69.1856 154.207 78.5954C153.981 78.8979 153.553 78.9602 153.251 78.7346C152.948 78.509 152.886 78.0809 153.111 77.7785C160.391 68.0193 171.54 62.4221 183.7 62.4221C204.729 62.4221 221.837 79.5304 221.837 100.559C221.837 121.588 204.729 138.696 183.7 138.696Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3183 111.9C86.1587 111.9 87.6507 110.408 87.6507 108.568C87.6507 106.728 86.1587 105.236 84.3183 105.236C82.4778 105.236 80.9858 106.728 80.9858 108.568C80.9858 110.408 82.4778 111.9 84.3183 111.9Z",
    fill: "url(#paint26_linear_171_1178)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M101.111 71.7746C101.111 78.1126 91.5653 94.282 86.5925 102.258C86.2067 102.877 85.3754 103.253 83.8363 103.253C83.1069 103.253 83.3938 102.875 83.0079 102.256C78.0349 94.2797 68.4902 78.1118 68.4902 71.7746C68.4902 63.5104 75.7927 56.8108 84.8008 56.8108C93.8087 56.8109 101.111 63.5104 101.111 71.7746Z",
    fill: "url(#paint27_linear_171_1178)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M100.147 71.7746C100.147 78.1126 90.6007 94.282 85.628 102.258C85.2421 102.877 84.5642 103.253 83.8349 103.253C83.1055 103.252 82.4292 102.875 82.0433 102.256C77.0703 94.2797 67.5256 78.1118 67.5256 71.7746C67.5256 63.5104 74.8281 56.8108 83.8362 56.8108C92.8443 56.8109 100.147 63.5104 100.147 71.7746Z",
    fill: "url(#paint28_linear_171_1178)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8362 84.5874C90.3803 84.5874 95.6853 79.2824 95.6853 72.7383C95.6853 66.1942 90.3803 60.8892 83.8362 60.8892C77.2921 60.8892 71.9871 66.1942 71.9871 72.7383C71.9871 79.2824 77.2921 84.5874 83.8362 84.5874Z",
    fill: "url(#paint29_linear_171_1178)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9275 79.466H75.8765V69.4574H91.8042V69.7039H76.123V79.2195H91.681V70.3517H91.9275V79.466Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3459 78.9948H77.4573V73.8032C77.4573 73.5399 77.6707 73.3264 77.934 73.3264H80.9571C81.1718 73.3264 81.3459 73.5004 81.3459 73.7152V78.9948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2585 79.6406H77.3999C77.3518 79.6406 77.3127 79.6016 77.3127 79.5535V79.0691C77.3127 79.0069 77.3631 78.9565 77.4253 78.9565H81.2332C81.2954 78.9565 81.3457 79.0069 81.3457 79.0691V79.5535C81.3458 79.6016 81.3067 79.6406 81.2585 79.6406Z",
    fill: "white"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M90.1401 77.1945H82.9166C82.7369 77.1945 82.5913 77.0489 82.5913 76.8692V72.3414C82.5913 72.1798 82.7223 72.0488 82.8839 72.0488H90.1401C90.3198 72.0488 90.4654 72.1945 90.4654 72.3741V76.8692C90.4655 77.0489 90.3198 77.1945 90.1401 77.1945Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.2585 79.6406H77.3999C77.3518 79.6406 77.3127 79.6016 77.3127 79.5535V79.0691C77.3127 79.0069 77.3631 78.9565 77.4253 78.9565H81.2332C81.2954 78.9565 81.3457 79.0069 81.3457 79.0691V79.5535C81.3458 79.6016 81.3067 79.6406 81.2585 79.6406Z",
    fill: "white"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0829 69.8354L78.249 69.8265L78.2652 69.6893C78.3616 68.8689 78.6511 67.3327 79.5071 66.2631L79.5441 66.2169H81.9413L81.8333 66.4023C81.3042 67.3096 81.1361 68.7059 81.0884 69.7175L81.0829 69.8354ZM78.527 69.5809L80.8481 69.5879C80.9011 68.6276 81.0636 67.3707 81.52 66.4634H79.663C78.9178 67.4261 78.6339 68.7747 78.527 69.5809Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4971 69.8272L75.9253 69.8195L75.9514 69.6748C76.1339 68.6671 76.5537 67.2557 77.518 66.2547L77.5544 66.2169H79.8598L79.6995 66.4172C78.8819 67.4386 78.6033 68.9238 78.51 69.7182L78.4971 69.8272ZM76.2213 69.5739L78.2786 69.5802C78.3804 68.7918 78.6502 67.469 79.3568 66.4634H77.6595C76.8077 67.3707 76.4083 68.6262 76.2213 69.5739Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.522 69.8429L80.8359 69.8344L80.842 69.7059C80.8911 68.6666 81.066 67.2284 81.6202 66.278L81.6559 66.2169H83.5221L83.522 69.8429ZM81.0949 69.5889L83.2755 69.5953V66.4633H81.7984C81.3182 67.3327 81.1494 68.6132 81.0949 69.5889Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1761 69.8201L74.4262 69.8148L74.4144 69.705C74.412 69.6831 74.204 67.5088 76.4068 66.2334L76.4354 66.2168H77.8971L77.6959 66.4255C76.7746 67.3822 76.3709 68.7443 76.1945 69.7186L76.1761 69.8201ZM74.6542 69.569L75.9709 69.5731C76.1494 68.6436 76.5281 67.4098 77.3298 66.4633H76.5018C74.7418 67.4992 74.6464 69.1333 74.6542 69.569Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1643 69.8662L88.5881 69.8584L88.5757 69.7494C88.484 68.9472 88.2072 67.4474 87.3825 66.4171L87.2222 66.2168H89.5277L89.5641 66.2546C90.5399 67.2673 90.9591 68.6988 91.139 69.7209L91.1643 69.8662ZM88.8075 69.6124L90.8694 69.6187C90.6848 68.6567 90.2854 67.3825 89.4225 66.4633H87.725C88.4387 67.4785 88.7072 68.8161 88.8075 69.6124Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M93.18 69.8725L90.914 69.8655L90.8961 69.7639C90.7223 68.7754 90.3192 67.3939 89.3867 66.4256L89.1855 66.2169L90.7193 66.2268C90.744 66.2374 93.1801 67.3099 93.1801 69.7487L93.18 69.8725ZM91.1205 69.6194L92.9313 69.625C92.8549 67.5553 90.8761 66.5715 90.6441 66.4633H89.7528C90.5653 67.4225 90.9442 68.6757 91.1205 69.6194Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2469 69.8513L83.2759 69.8419V66.2169H85.4263L85.462 66.278C86.0182 67.2321 86.1925 68.6775 86.2409 69.7218L86.2469 69.8513ZM83.5224 69.5964L85.9881 69.6039C85.9342 68.6233 85.7658 67.3361 85.2837 66.4635H83.5224V69.5964Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8361 69.8592L85.9997 69.8503L85.9943 69.7333C85.9472 68.7164 85.7797 67.3129 85.2486 66.4023L85.1406 66.2169H87.5377L87.5747 66.2631C88.4381 67.3416 88.7258 68.8929 88.8204 69.7215L88.8361 69.8592ZM86.2347 69.6045L88.5587 69.6117C88.4536 68.7976 88.171 67.4348 87.4187 66.4634H85.5619C86.0204 67.3748 86.1824 68.6387 86.2347 69.6045Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4546 69.7179C74.4546 69.7179 74.2274 67.6159 76.3862 66.3661H77.5248C76.5648 67.3628 76.1593 68.7925 75.9909 69.7227L74.4546 69.7179Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2759 69.7222C78.3911 68.7413 78.7058 67.3401 79.4916 66.3585H81.6151C81.0693 67.2948 80.9009 68.7296 80.8535 69.7301L78.2759 69.7222Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4414 69.7297V66.3507H85.3977C85.9464 67.2919 86.1137 68.737 86.16 69.7381L83.4414 69.7297Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6979 69.7353C88.5857 68.7531 88.2728 67.3323 87.4785 66.34H89.4751C90.4511 67.3531 90.854 68.8139 91.0173 69.7423L88.6979 69.7353Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4751 69.6958C74.4751 69.6958 74.3618 70.4013 75.1546 70.4013C75.9473 70.4013 76.1172 69.637 76.1172 69.637L74.4751 69.6958Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0154 69.637H78.439C78.439 69.637 78.6651 70.5189 79.7979 70.5189C80.552 70.5189 80.9526 70.1661 81.0154 69.637Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7867 70.5245C89.0432 70.5245 88.6512 70.2385 88.5883 69.6499L88.5737 69.5137H91.1972L91.1506 69.6718C91.148 69.6803 90.8869 70.5245 89.7867 70.5245ZM88.8568 69.7602C88.9463 70.1215 89.2329 70.278 89.7867 70.278C90.4237 70.278 90.7171 69.9604 90.839 69.7602H88.8568Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4502 69.637H86.2192C86.2192 69.637 85.9762 70.5189 84.7586 70.5189C83.9481 70.5189 83.5177 70.1661 83.4502 69.637Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1546 70.5246C74.8688 70.5246 74.6527 70.4408 74.512 70.2759C74.3 70.0272 74.3512 69.6904 74.3535 69.6762L74.3695 69.5761L76.2723 69.5082L76.2377 69.6637C76.1714 69.9615 75.8598 70.5246 75.1546 70.5246ZM74.5936 69.8149C74.5974 69.8996 74.6188 70.0221 74.7007 70.1172C74.7925 70.2239 74.9452 70.2781 75.1546 70.2781C75.6313 70.2781 75.8502 69.9644 75.941 69.7668L74.5936 69.8149Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3631 70.5245C76.2628 70.5245 76.0016 69.6803 75.9992 69.6716L75.9526 69.5137H78.5761L78.5615 69.6499C78.4986 70.2385 78.1066 70.5245 77.3631 70.5245ZM76.3108 69.7602C76.4325 69.9602 76.7259 70.278 77.3631 70.278C77.9169 70.278 78.2035 70.1215 78.293 69.7602H76.3108Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7979 70.6423C78.5834 70.6423 78.322 69.6774 78.3195 69.6675L78.28 69.5137H81.1542L81.1378 69.6514C81.063 70.2812 80.5746 70.6423 79.7979 70.6423ZM78.6209 69.7602C78.7391 69.9904 79.0531 70.3958 79.7979 70.3958C80.3825 70.3958 80.7565 70.1714 80.8667 69.7602H78.6209Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2864 70.6422C81.1203 70.6422 80.8698 69.6759 80.8674 69.6663L80.8301 69.5137H83.5885L83.5728 69.6509C83.5013 70.2809 83.0324 70.6422 82.2864 70.6422ZM81.166 69.7602C81.2782 69.9898 81.577 70.3957 82.2864 70.3957C82.8425 70.3957 83.1981 70.1714 83.303 69.7602H81.166Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2079 70.5246C91.1455 70.5246 90.9004 69.6782 90.8982 69.6697L90.854 69.5089L93.1502 69.5754L93.1694 69.6716C93.1719 69.6842 93.228 69.9812 93.0272 70.2258C92.8645 70.4239 92.5888 70.5246 92.2079 70.5246ZM91.2087 69.7657C91.3249 69.9653 91.6033 70.278 92.2079 70.278C92.5114 70.278 92.723 70.2077 92.8368 70.0693C92.9066 69.9841 92.927 69.8861 92.9313 69.8155L91.2087 69.7657Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7104 69.637H91.0321C91.0321 69.637 90.8071 70.4013 89.7864 70.4013C89.1068 70.4013 88.7671 70.1661 88.7104 69.637Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3425 70.6422C86.558 70.6422 86.0649 70.2811 85.9892 69.6516L85.9727 69.5137H88.8756L88.8356 69.6677C88.8331 69.6776 88.569 70.6422 87.3425 70.6422ZM86.2605 69.7602C86.3722 70.1714 86.7506 70.3957 87.3425 70.3957C88.0901 70.3957 88.4106 69.9901 88.5321 69.7602H86.2605Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7585 70.6423C83.9295 70.6423 83.408 70.2817 83.3277 69.6526L83.3101 69.5137H86.3808L86.3379 69.6696C86.3352 69.6794 86.0549 70.6423 84.7585 70.6423ZM83.6009 69.7602C83.7204 70.1714 84.1252 70.3958 84.7585 70.3958C85.5628 70.3958 85.9029 69.9916 86.0316 69.7602H83.6009Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8831 69.6245H74.4816L74.4491 69.5347C74.4364 69.5158 74.5154 69.499 74.6174 69.499L92.845 69.4989C92.917 69.499 92.9812 69.5073 93.0065 69.5199L93.0457 69.5394C93.0882 69.5607 93.0043 69.5833 92.8831 69.6245Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8361 85.0884C77.1644 85.0884 71.7366 79.6606 71.7366 72.9887C71.7366 72.869 71.8336 72.7719 71.9534 72.7719C72.0732 72.7719 72.1702 72.869 72.1702 72.9887C72.1702 79.4214 77.4035 84.6548 83.8362 84.6548C90.2689 84.6548 95.5023 79.4214 95.5023 72.9887C95.5023 66.556 90.2689 61.3227 83.8362 61.3227C80.1165 61.3227 76.706 63.035 74.4791 66.0204C74.4075 66.1164 74.2714 66.1362 74.1757 66.0646C74.0797 65.993 74.0599 65.8572 74.1314 65.7612C76.4411 62.665 79.9783 60.8892 83.8361 60.8892C90.5079 60.8892 95.9358 66.317 95.9358 72.9888C95.9358 79.6606 90.5079 85.0884 83.8361 85.0884Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M135.35 182.793C135.265 182.793 135.189 182.731 135.176 182.644C135.167 182.592 134.341 177.461 132.771 176.566C132.521 176.425 132.273 176.406 132.012 176.51C129.906 177.349 130.984 182.175 130.995 182.223C131.017 182.319 130.958 182.413 130.862 182.435C130.77 182.458 130.673 182.398 130.65 182.302C130.602 182.092 129.495 177.131 131.881 176.182C132.243 176.037 132.602 176.063 132.946 176.259C134.664 177.237 135.491 182.371 135.525 182.589C135.54 182.685 135.475 182.776 135.378 182.791C135.369 182.792 135.359 182.793 135.35 182.793Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M137.538 182.254L129.344 181.497L127.52 182.508L129.083 184.464L136.567 183.702L137.538 182.254Z",
    fill: "url(#paint30_linear_171_1178)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M116.825 112.532C118.733 112.062 127.107 117.251 126.524 124.719C125.942 132.187 129.907 134.448 131.445 138.236C132.984 142.024 138.918 153.178 130.786 155.037C122.654 156.897 121.461 151.775 118.619 152.914C115.777 154.053 109.899 152.648 110.384 148.781C110.869 144.915 110.573 114.071 116.825 112.532Z",
    fill: "url(#paint31_linear_171_1178)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M89.518 114.338C89.518 114.338 101.551 132.608 115.517 135.92C115.517 135.92 112.952 143.685 110.878 144.606C110.878 144.606 93.5125 130.657 88.8618 116.978L89.518 114.338Z",
    fill: "url(#paint32_linear_171_1178)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M136.354 232.148L136.49 235.283C136.515 235.877 136.943 236.379 137.527 236.493C138.514 236.684 140.102 236.925 141.678 236.882C142.37 236.863 142.87 236.203 142.712 235.529C142.424 234.3 141.868 232.446 140.945 231.309L137.5 231.041C136.863 230.991 136.326 231.51 136.354 232.148Z",
    fill: "url(#paint33_linear_171_1178)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M112.209 193.667L111.361 197.042C111.361 197.042 111.771 216.916 111.502 224.832C111.46 226.073 111.044 227.27 110.313 228.274L106.499 233.508L115.499 229.101L115.752 228.065L114.495 226.018L118.062 204.068C118.272 202.778 118.106 201.456 117.583 200.258L116.064 196.776L112.209 193.667Z",
    fill: "url(#paint34_linear_171_1178)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M105.87 234.26L108.616 234.474C109.13 234.514 109.633 234.316 109.978 233.933C110.921 232.888 112.864 230.856 113.716 230.865C114.864 230.878 114.401 234.925 114.401 234.925L115.041 234.975L116.245 229.995C116.548 228.742 116.015 227.436 114.922 226.752C114.922 226.752 114.51 228.662 113.029 229.405C111.547 230.149 106.965 232.867 106.965 232.867C106.965 232.867 106.439 232.75 105.847 232.81C104.968 232.899 104.989 234.191 105.87 234.26Z",
    fill: "url(#paint35_linear_171_1178)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M123.869 196.21C123.869 196.21 133.588 218.737 135.016 223.818C136.444 228.9 136.758 233.071 136.752 233.463C136.743 234.076 137.455 234.72 139.546 234.883C140.625 234.967 141.187 234.575 141.479 234.177C141.727 233.837 141.774 233.391 141.617 233C141.061 231.613 139.3 227.183 138.675 225.187C137.93 222.803 136.754 212.175 135.946 208.449C135.138 204.723 134.211 200.677 129.738 196.668C129.738 196.668 126.722 193.215 123.869 196.21Z",
    fill: "url(#paint36_linear_171_1178)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M119.427 160.194C117.457 147.496 125.461 141.026 125.461 141.026C121.109 136.144 112.7 133.422 112.7 133.422C112.7 133.422 104.057 138.762 104.662 143.517C105.017 146.304 109.129 160.393 109.129 160.393C109.129 160.393 113.741 163.033 119.427 160.194Z",
    fill: "url(#paint37_linear_171_1178)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M125.469 166.875C124.553 163.175 119.427 160.194 119.427 160.194C113.741 163.033 109.129 160.393 109.129 160.393C109.129 160.393 107.735 164.414 108.179 168.287C108.622 172.16 111.361 197.041 111.361 197.041C118.574 199.098 130.076 196.998 130.076 196.998C126.055 188.347 126.386 170.576 125.469 166.875Z",
    fill: "url(#paint38_linear_171_1178)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M118.688 125.599L120.243 136.531C120.398 137.496 119.547 137.273 118.604 137.018C117.06 136.601 115.088 135.835 114.508 134.563C114.449 134.433 114.425 134.29 114.417 134.148L113.97 126.617C113.935 126.019 114.299 125.471 114.863 125.271L116.915 124.547C117.705 124.267 118.555 124.772 118.688 125.599Z",
    fill: "url(#paint39_linear_171_1178)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M114.464 116.449C114.464 116.449 111.728 117.875 110.133 122.124C108.539 126.373 110.13 128.147 111.958 128.26C113.786 128.373 116.484 128.115 119.128 125.239C121.771 122.363 118.031 114.733 114.464 116.449Z",
    fill: "url(#paint40_linear_171_1178)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M117.03 123.209C117.03 123.209 118.682 117.048 113.367 117.407L112.188 118.382C112.188 118.382 109.971 115.219 113.04 113.375C116.109 111.531 119.701 112.556 122.812 115.852C126.18 119.419 127.633 124.015 125.536 126.259C123.439 128.503 118.849 126.605 118.849 126.605C118.849 126.605 118.331 125.336 119.018 123.006C119.343 121.903 117.376 123.354 117.376 123.354L117.03 123.209Z",
    fill: "url(#paint41_linear_171_1178)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M117.679 123.828C117.679 123.828 118.51 120.656 120.051 121.768C121.592 122.879 119.11 124.712 118.13 125.32L117.679 123.828Z",
    fill: "url(#paint42_linear_171_1178)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6564 118.447C89.5822 118.823 90.9663 119.23 91.5816 117.659C91.5304 116.944 91.6273 113.846 91.138 113.313C88.5318 110.473 83.712 107.085 83.712 107.085C83.0503 107.899 83.7413 108.551 83.7413 108.551L86.1169 110.537C85.7599 111.391 85.2911 112.131 85.1437 113.134C85.0319 113.893 85.2369 114.668 85.6836 115.299C86.132 115.931 86.7388 116.751 87.2968 117.384C88.3532 118.581 89.6564 118.447 89.6564 118.447Z",
    fill: "url(#paint43_linear_171_1178)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5554 117.222C88.4727 117.205 88.4013 117.144 88.3757 117.057C88.1176 116.182 87.3611 113.8 86.9649 113.291C86.6805 112.925 86.5656 112.604 86.6144 112.311C86.6554 112.063 86.8071 111.856 87.0786 111.677C87.1575 111.624 87.2606 111.626 87.3402 111.678L89.4634 113.111C89.4968 113.134 89.524 113.164 89.5421 113.201L90.3328 114.772C90.391 114.889 90.3443 115.03 90.228 115.089C90.1121 115.147 89.9699 115.101 89.9112 114.985L89.1485 113.468L87.2164 112.164C87.1374 112.236 87.0925 112.311 87.0798 112.387C87.0547 112.54 87.1436 112.752 87.3374 113.001C87.86 113.673 88.7307 116.593 88.8285 116.923C88.8653 117.048 88.7938 117.18 88.6688 117.217C88.6307 117.228 88.592 117.229 88.5554 117.222Z",
    fill: "url(#paint44_linear_171_1178)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M141.493 201.849L144.302 200.234L137.538 182.254L135.915 183.35L141.493 201.849Z",
    fill: "url(#paint45_linear_171_1178)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M133.867 184.748C133.863 184.748 133.858 184.748 133.853 184.748C133.756 184.74 133.683 184.655 133.691 184.557C133.695 184.505 134.056 179.302 132.582 177.617C132.308 177.303 131.997 177.14 131.63 177.12C131.28 177.099 130.959 177.222 130.666 177.495C129.077 178.975 128.983 184.127 128.982 184.179C128.981 184.276 128.902 184.353 128.805 184.353C128.804 184.353 128.803 184.353 128.803 184.353C128.705 184.352 128.627 184.271 128.628 184.174C128.631 183.956 128.725 178.819 130.425 177.236C130.786 176.899 131.199 176.742 131.65 176.766C132.11 176.792 132.513 177 132.849 177.384C134.443 179.207 134.048 184.531 134.044 184.585C134.036 184.678 133.959 184.748 133.867 184.748Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M121.541 145.971C121.943 146.504 128.032 153.747 129.776 161.83C131.519 169.913 130.933 175.31 130.933 175.31C130.933 175.31 129.161 176.632 129.798 177.569C130.435 178.506 130.267 179.143 131.081 179.325C131.895 179.507 132.905 179.763 132.781 178.156C132.658 176.549 134.577 176.225 134.258 175.254C133.941 174.287 136.112 148.201 125.61 141.125C125.56 141.091 125.511 141.058 125.46 141.026C121.021 142.63 120.896 145.115 121.541 145.971Z",
    fill: "url(#paint46_linear_171_1178)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M127.516 182.567L135.915 183.35L141.493 201.849L129.435 202.164L127.516 182.567Z",
    fill: "url(#paint47_linear_171_1178)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M141.662 201.566C141.652 201.566 141.642 201.565 141.632 201.562C141.569 201.546 141.531 201.481 141.548 201.418L142.086 199.364L137.833 186.167C137.813 186.106 137.847 186.039 137.91 186.019C137.972 185.999 138.037 186.033 138.058 186.095L142.321 199.325C142.328 199.346 142.329 199.369 142.323 199.391L141.776 201.478C141.762 201.531 141.714 201.566 141.662 201.566Z",
    fill: "url(#paint48_linear_171_1178)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M144.099 200.277C144.082 200.277 144.065 200.274 144.048 200.266L142.594 199.57C142.535 199.542 142.51 199.472 142.538 199.413C142.566 199.354 142.637 199.329 142.696 199.358L144.15 200.053C144.209 200.081 144.234 200.151 144.206 200.21C144.185 200.253 144.143 200.277 144.099 200.277Z",
    fill: "url(#paint49_linear_171_1178)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_171_1178",
    x1: 244.483,
    y1: 275.981,
    x2: 77.6233,
    y2: 68.7528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_171_1178",
    x1: 66.0088,
    y1: 34.9585,
    x2: 54.8569,
    y2: 162.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_171_1178",
    x1: 36.6965,
    y1: 72.7366,
    x2: 67.7229,
    y2: 130.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18459F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2874B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_171_1178",
    x1: 119.698,
    y1: 36.2563,
    x2: 83.709,
    y2: -110.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_171_1178",
    x1: 129.141,
    y1: 144.458,
    x2: -44.7782,
    y2: 145.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_171_1178",
    x1: 60.6397,
    y1: 149.391,
    x2: 278.309,
    y2: 138.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_171_1178",
    x1: 172.175,
    y1: 146.238,
    x2: 396.803,
    y2: 146.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_171_1178",
    x1: 320.562,
    y1: -86.51,
    x2: 22.1547,
    y2: 329.642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_171_1178",
    x1: 110.403,
    y1: 86.5075,
    x2: 98.5408,
    y2: 128.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_171_1178",
    x1: 227.787,
    y1: 138.121,
    x2: 221.856,
    y2: 202.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_171_1178",
    x1: 130.394,
    y1: 155.773,
    x2: 111.81,
    y2: 203.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_171_1178",
    x1: 261.936,
    y1: -128.548,
    x2: -36.471,
    y2: 287.604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_171_1178",
    x1: 362.982,
    y1: -56.0922,
    x2: 64.5748,
    y2: 360.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_171_1178",
    x1: 281.201,
    y1: -114.734,
    x2: -17.2061,
    y2: 301.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_171_1178",
    x1: 328.079,
    y1: -81.1188,
    x2: 29.6719,
    y2: 335.033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_171_1178",
    x1: 299.224,
    y1: -101.811,
    x2: 0.81563,
    y2: 314.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_171_1178",
    x1: 331.079,
    y1: -78.9681,
    x2: 32.6723,
    y2: 337.184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_171_1178",
    x1: 304.14,
    y1: -98.2854,
    x2: 5.73228,
    y2: 317.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_171_1178",
    x1: 289.586,
    y1: -108.72,
    x2: -8.82032,
    y2: 307.431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_171_1178",
    x1: 320.848,
    y1: -86.3045,
    x2: 22.4415,
    y2: 329.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_171_1178",
    x1: 332.794,
    y1: -77.7385,
    x2: 34.3869,
    y2: 338.414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_171_1178",
    x1: 300.684,
    y1: -100.764,
    x2: 2.27649,
    y2: 315.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3840F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_171_1178",
    x1: 158.471,
    y1: 251.251,
    x2: 293.153,
    y2: 57.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_171_1178",
    x1: 286.959,
    y1: 35.5623,
    x2: 109.531,
    y2: 177.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_171_1178",
    x1: 221.186,
    y1: 53.1111,
    x2: 81.8293,
    y2: 248.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_171_1178",
    x1: -18.1913,
    y1: 301.057,
    x2: 221.732,
    y2: 61.8519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_171_1178",
    x1: 75.8318,
    y1: 120.798,
    x2: 118.562,
    y2: 59.2168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_171_1178",
    x1: 116.597,
    y1: 52.3674,
    x2: 60.3049,
    y2: 97.4922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_171_1178",
    x1: 81.4533,
    y1: 77.9509,
    x2: 37.24,
    y2: 139.941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB236D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C246D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_171_1178",
    x1: 19.7826,
    y1: 136.6,
    x2: 95.9024,
    y2: 60.7083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_171_1178",
    x1: 138.56,
    y1: 177.486,
    x2: 128.195,
    y2: 186.424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_171_1178",
    x1: 106.963,
    y1: 98.2119,
    x2: 116.002,
    y2: 127.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_171_1178",
    x1: 93.4042,
    y1: 127.918,
    x2: 119.273,
    y2: 133.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_171_1178",
    x1: 136.222,
    y1: 233.74,
    x2: 142.863,
    y2: 234.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_171_1178",
    x1: 106.119,
    y1: 257.741,
    x2: 124.381,
    y2: 146.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_171_1178",
    x1: 105.462,
    y1: 230.122,
    x2: 116.208,
    y2: 230.959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_171_1178",
    x1: 125.215,
    y1: 260.903,
    x2: 143.482,
    y2: 149.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_171_1178",
    x1: 114.88,
    y1: 145.321,
    x2: 152.485,
    y2: 69.6857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D93C65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_171_1178",
    x1: 131.648,
    y1: 162.077,
    x2: 53.3663,
    y2: 270.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_171_1178",
    x1: 116.851,
    y1: 141.278,
    x2: 117.555,
    y2: 115.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_171_1178",
    x1: 110.694,
    y1: 132.366,
    x2: 124.098,
    y2: 103.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_171_1178",
    x1: 136.467,
    y1: 134.95,
    x2: 124.866,
    y2: 124.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B3582"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#150E42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_171_1178",
    x1: 114.18,
    y1: 133.969,
    x2: 127.583,
    y2: 104.831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_171_1178",
    x1: 95.0446,
    y1: 125.793,
    x2: 113.086,
    y2: 157.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_171_1178",
    x1: 94.2341,
    y1: 123.838,
    x2: 87.49,
    y2: 112.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_171_1178",
    x1: 141.416,
    y1: 186.027,
    x2: 135.827,
    y2: 210.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C32B78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593092"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_171_1178",
    x1: 127.886,
    y1: 164.213,
    x2: 127.194,
    y2: 128.058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B776"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47960"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_171_1178",
    x1: 164.486,
    y1: 151.938,
    x2: 115.203,
    y2: 218.133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A737D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF497A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_171_1178",
    x1: 140.247,
    y1: 201.593,
    x2: 139.948,
    y2: 185.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_171_1178",
    x1: 143.381,
    y1: 200.291,
    x2: 143.363,
    y2: 199.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B37CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F895E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussinessStep2);
export default __webpack_public_path__ + "static/media/bussinessStep2.51db00042eeabc9a3a2423c762847537.svg";
export { ForwardRef as ReactComponent };